import request from '../utils/request'

export function loginRequest(data) {
  return request({
    url: 'dashboard/login',
    method: 'post',
    data
  })
}

export function findAllUserRequest() {
  return request({
    url: 'dashboard/users',
    method: 'get'
  })
}

export function savedRequest(data) {
  return request({
    url: 'dashboard/save/user',
    method: 'post',
    data
  })
}

export function updateRequest(data) {
  return request({
    url: 'dashboard/update/user',
    method: 'post',
    data
  })
}
